import { render, staticRenderFns } from "./BuyerDashboardCampaigns.vue?vue&type=template&id=4c86e505&scoped=true"
import script from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"
export * from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86e505",
  null
  
)

export default component.exports